import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next'; // Add this import
import backgroundImage from '../../images/section-2-bg.png';
import backgroundImageSmall from '../../images/section-2-mobile.png';
import fs3 from '../../images/fs-3.png';
import { Button } from 'components';
import { useNavigate } from 'react-router-dom';

export const Section2 = () => {
  const { t } = useTranslation(); // Hook for translations
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <section
      className="flex flex-col-reverse md:flex-row items-center justify-between px-smallPx md:px-mediumPx lg:px-largePx lg:h-[530px] md:space-y-0 py-20"
      style={{
        backgroundImage: `url(${isSmallScreen ? backgroundImageSmall : backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <div className="content-center space-y-6 md:w-[70%] py-10">
        <div>
          <h1 className="text-[24px] font-bold text-[#1E90AA]">
            {t('section2.title1')}
          </h1>
          <p className="md:ml-5">{t('section2.paragraph1')}</p>
        </div>
        <div>
          <h1 className="text-[24px] font-bold text-[#1E90AA]">
            {t('section2.title2')}
          </h1>
          <p className="md:ml-5">{t('section2.paragraph2')}</p>
        </div>
        <Button
          text={t('section2.button')}
          className="text-white hover:text-black"
          onClick={() => navigate('/about')}
        />
      </div>
      <img
        src={fs3}
        className="h-[300px] w-[300px] mb-10 md:mb-0"
        alt={t('section2.imageAlt')}
      />
    </section>
  );
};

export default Section2;
